// client/src/components/Admin/Dashboard/_shared/FunnelWidget.js
//
// F1B M7.4 - Widget de funnel publico pre-registro K12.
// Lee el bloque `funnel` del endpoint /dashboard/vertical/k12 y muestra:
//   - 4 KPI cards: page views, plan CTA clicks, leads enterprise, conversion %
//   - Tabla por plan (clicks)
//   - Mini chart de visits monthly (opcional)
//   - Estado "sin datos aun" si los totales estan en 0
//
// Estetica homologa a AnalyticsWidget pero con un badge distinto que indica
// que son datos publicos pre-registro (no analytics de uso interno).

import React from "react";
import styles from "./FunnelWidget.module.scss";

function formatNumber(n) {
  if (n === null || n === undefined) return "-";
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
}

const PLAN_LABELS = {
  free: "Educa-Free",
  standard: "Educa-Estandar",
  creator: "Educa-Creator",
  enterprise: "Educa-Centro",
};

export function FunnelWidget({ title = "Funnel publico K12", funnel }) {
  if (!funnel || !funnel.totals) return null;

  const { totals, byPlan = [] } = funnel;
  const isEmpty =
    totals.pageViews === 0 &&
    totals.planCtaClicks === 0 &&
    totals.enterpriseLeads === 0;

  return (
    <div className={styles.funnelWidget}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        <span className={styles.badge}>Pre-registro</span>
      </div>

      {isEmpty ? (
        <div className={styles.empty}>
          Aun no hay datos del funnel publico. Los eventos se registran cuando
          un visitante visita /planes o hace clic en una CTA de plan.
        </div>
      ) : (
        <>
          <div className={styles.miniKpis}>
            <div className={styles.miniKpi}>
              <div className={styles.miniLabel}>Visitas</div>
              <div className={styles.miniValue}>
                {formatNumber(totals.pageViews)}
              </div>
            </div>
            <div className={styles.miniKpi}>
              <div className={styles.miniLabel}>Clicks CTA plan</div>
              <div className={styles.miniValue}>
                {formatNumber(totals.planCtaClicks)}
              </div>
            </div>
            <div className={styles.miniKpi}>
              <div className={styles.miniLabel}>Leads centros</div>
              <div className={styles.miniValue}>
                {formatNumber(totals.enterpriseLeads)}
              </div>
            </div>
            <div className={styles.miniKpi}>
              <div className={styles.miniLabel}>Conversion</div>
              <div className={styles.miniValue}>
                {totals.conversionRate != null
                  ? `${totals.conversionRate}%`
                  : "-"}
              </div>
            </div>
          </div>

          {byPlan.length > 0 && (
            <div className={styles.byPlan}>
              <div className={styles.byPlanTitle}>Clicks por plan</div>
              <ul className={styles.byPlanList}>
                {byPlan.map((row) => (
                  <li key={row.planKey} className={styles.byPlanRow}>
                    <span className={styles.byPlanName}>
                      {PLAN_LABELS[row.planKey] || row.planKey}
                    </span>
                    <span className={styles.byPlanCount}>
                      {formatNumber(row.clicks)}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </div>
  );
}
